(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video-lightbox"] && !Shopify.designMode) return;
  try {
    /* <wyrdo-video-lightbox> — a click on any [data-video-open] link opens the dialog and starts the video in the same
     tap; every way of closing pauses it. Modified clicks (new tab / window) keep the link's own behaviour. */
  if (!customElements.get('wyrdo-video-lightbox')) {
    customElements.define('wyrdo-video-lightbox', class extends HTMLElement {
      connectedCallback() {
        const dialog = this.querySelector('dialog'), video = this.querySelector('video');
        if (!dialog || !video) return;
        document.addEventListener('click', (e) => {
          const link = e.target.closest('[data-video-open]');
          if (!link || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          dialog.showModal();
          const p = video.play();
          if (p) p.catch(() => {});
        });
        // a tap on the dark backdrop closes it; a scrub that starts on the video and drifts off it does not
        let downOnBackdrop = false;
        dialog.addEventListener('pointerdown', (e) => { downOnBackdrop = e.target === dialog; });
        dialog.addEventListener('click', (e) => { if (downOnBackdrop && e.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["waitlist"] && !Shopify.designMode) return;
  try {
    /* <wyrdo-waitlist> — the regional sign-up (snippets/waitlist.liquid): one POST to our server (I.19), else
     Klaviyo's client subscriptions API as before, then the success line in place of the form (or the error line, form kept). */
  if (!customElements.get('wyrdo-waitlist')) {
    customElements.define('wyrdo-waitlist', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-wl-form]');
        this.msg = this.querySelector('[data-wl-msg]');
        if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
      }

      async send() {
        const btn = this.form.querySelector('button');
        const email = this.form.elements.email.value.trim();
        if (!email || btn.disabled) return;
        btn.disabled = true;
        this.say('');
        const d = this.dataset;
        let status = 0, error = '';
        try {
          const ctl = new AbortController();
          const timer = setTimeout(() => ctl.abort(), 8000);
          const r = await fetch(d.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, region: d.region, consentText: d.consent }),
            signal: ctl.signal,
          });
          clearTimeout(timer);
          status = r.status;
          if (status === 400) error = ((await r.json().catch(() => null)) || {}).error;
        } catch (err) {
          console.warn('wyrdo-waitlist: server', err);
        }
        if (status >= 200 && status < 300) return this.done(email);
        if (status === 429 || error === 'invalid_email') {   // too many tries, try again in a minute · the email was refused
          this.say(status === 429 ? d.retry : d.error, 'is-error');
          btn.disabled = false;
          return;
        }
        if (status) console.warn('wyrdo-waitlist: server', status, error);
        // anything else (no answer, timeout, 403, 5xx, a 400 that's our setup — e.g. blank fine print) = the
        // pre-I.19 path, straight to Klaviyo
        const body = { data: { type: 'subscription', attributes: { custom_source: 'store_pdp', profile: { data: { type: 'profile', attributes: {
          email,
          properties: { wyrdo_market: d.region, wyrdo_lead_source: 'store_pdp', wyrdo_marketing_consent: true, wyrdo_consent_at: new Date().toISOString(), wyrdo_consent_text: d.consent },
        } } } }, relationships: { list: { data: { type: 'list', id: d.list } } } } };
        let res = null;
        try {
          res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + d.company, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify(body),
            signal: window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(10000) : undefined,   // Safari < 16 has no timeout()
          });
        } catch (err) {
          console.warn('wyrdo-waitlist:', err);
        }
        if (!res || !res.ok) {
          if (res) console.warn('wyrdo-waitlist: klaviyo', res.status);
          this.say(res && res.status === 400 ? d.error : d.retry, 'is-error');   // 400 = Klaviyo refused the email
          btn.disabled = false;
          return;
        }
        this.done(email);
      }

      done(email) {
        this.form.hidden = true;
        this.say(this.dataset.success, 'is-done');
        this.msg.tabIndex = -1; this.msg.focus();   // the focused button just disappeared with the form
        try { window.klaviyo && window.klaviyo.identify({ $email: email }); } catch (err) { /* the pop-up just won't know them */ }
      }

      say(text, cls) {
        this.msg.className = 'wyrdo-wl__msg' + (cls ? ' ' + cls : '');
        this.msg.textContent = text || '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
